import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../hooks/useAuthContext';
import { Bars3Icon, UserCircleIcon, ArrowRightOnRectangleIcon, UserPlusIcon } from '@heroicons/react/24/outline';

const Header = ({ onMenuClick }) => {
  const { user, dispatch } = useAuthContext();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch({ type: 'LOGOUT' });
    setIsDropdownOpen(false);
    navigate('/');
  };

  return (
    <header className="bg-orange-500 shadow-md fixed top-0 w-full z-40 text-white">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Left section: Menu button */}
          <div className="flex-none">
            <button
              onClick={onMenuClick}
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:bg-orange-600 focus:outline-none"
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" />
            </button>
          </div>

          {/* Center section: Title */}
          <div className="flex-grow text-center">
            <Link to="/" className="flex items-center justify-center space-x-3">
              <h1 className="text-lg sm:text-xl font-bold">सैनिक शिरोमणि सिखेड़ा</h1>
            </Link>
          </div>

          {/* Right section: Auth links and dropdown */}
          <div className="flex-none">
            {user ? (
              <div className="relative">
                <button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="p-2 rounded-md hover:bg-orange-600"
                >
                  <UserCircleIcon className="h-8 w-8" />
                </button>
                {isDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 text-gray-700">
                    <Link
                      to="/profile"
                      className="flex items-center px-4 py-2 text-sm hover:bg-gray-100"
                      onClick={() => setIsDropdownOpen(false)}
                    >
                      <UserCircleIcon className="h-5 w-5 mr-3" />
                      Profile
                    </Link>
                    <button
                      onClick={handleLogout}
                      className="flex items-center w-full px-4 py-2 text-sm hover:bg-gray-100"
                    >
                      <ArrowRightOnRectangleIcon className="h-5 w-5 mr-3" />
                      Logout
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className="flex items-center space-x-1 sm:space-x-2">
                <Link to="/login" className="flex items-center p-2 rounded-md hover:bg-orange-600">
                  <ArrowRightOnRectangleIcon className="h-6 w-6" />
                  <span className="hidden sm:inline ml-1">Sign In</span>
                </Link>
                <Link to="/signup" className="flex items-center p-2 rounded-md hover:bg-orange-600">
                  <UserPlusIcon className="h-6 w-6" />
                  <span className="hidden sm:inline ml-1">Sign Up</span>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
